import { createRouter, createWebHistory } from "vue-router";
import HomeComponent from "../components/homePage.vue";
import SearchResult from "../components/SearchResult.vue";
import flightInfo from "../components/flightInfo.vue";
import confirmBook from "../components/confirmBook.vue";
import bookingView from "../components/bookingView.vue";
import login from "../components/loginPage.vue";
import register from "../components/registerPage.vue";
import viewBooking from "../components/viewBooking.vue";
import myBooking from "../components/myBooking.vue";
import myProfile from "../components/myProfile.vue";
import aboutUs from "../components/aboutUs.vue";
import privacyPolicy from "../components/privacyPolicy.vue";
import termsUse from "../components/termsUse.vue";
import seatmap from "../components/seatMapping.vue";
import pageError from "../components/pageError.vue";
import pageNot from "../components/pageNot.vue";
import contactpage from '../components/contactPage.vue';
import newpassword from '../components/newPassword.vue';

const routes = [
  {
    path: "/",
    component: HomeComponent,
  },
  {
    path: "/flight/search",
    component: SearchResult,
  },
  {
    path: "/flightinfo",
    component: flightInfo,
  },
  {
    path: "/confirmBook",
    component: confirmBook,
  },
  {
    path: "/bookingView",
    component: bookingView,
  },
  {
    path: "/newPassword",
    component: newpassword,
  },
  {
    path: "/seatmap",
    component: seatmap,
  },
  {
    path: "/contact-us",
    component: contactpage,
  },
  {
    path: "/login",
    component: login,
  },
  {
    path: "/register",
    component: register,
  },
  {
    path: "/viewbooking",
    component: viewBooking,
  },
  {
    path: "/mybooking",
    component: myBooking,
  },
  {
    path: "/myProfile",
    component: myProfile,
  },
  {
    path: "/about-us",
    component: aboutUs,
  },
  {
    path: "/privacy-policy",
    component: privacyPolicy,
  },
  {
    path: "/terms-conditions",
    component: termsUse,
  },
  {
    path: "/pageError",
    component: pageError,
  },
  {
    path: "/pagenot",
    component: pageNot,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
